import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/base/baseCargo/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/base/baseCargo',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/base/baseCargo',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/base/baseCargo/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/base/baseCargo',
    method: 'get',
    params: {
      id
    }
  })
}
export function listOption(params) {
  return request({
    url: '/api/base/baseCargo/listOption',
    method: 'get',
    params
  })
}
